<template>
  <div style="display: flex; flex-flow: column; height: 100%; background: #0098E1;">
    <v-row class="my-0 mx-0" style="flex: 0 1 auto;">
      <div class="py-3" style="max-height: 15vh; width:100%">
        <v-img :src="ponceLogoUrl"></v-img>
      </div>
    </v-row>
    <div class="d-flex justify-center align-center" style="flex: 1;">
      <v-col class="px-10">
        <p class="text-h5 text-sm-h5 text-md-h3 font-weight-bold text-white text-center" v-text="$t(getMessageKey())"></p>
      </v-col>
    </div>
  </div>
</template>

<script>
import constants from '@/constants'

export default {
  name: 'empty-view',
  data () {
    return {
      ponceLogoUrl: process.env.VUE_APP_LOGO_URL
    }
  },
  created () {
    this.mixpanel.track_pageview({"page": "Empty"})
  },
  methods: {
    getMessageKey () {
      // Check if we're on the not-found route with campaign inactive reason
      if (this.$route.name === 'empty' && this.$route.path === '/not-found' && this.$route.query.reason === constants.URL_PARAMS.REASON.CAMPAIGN_INACTIVE) {
        return 'EmptyView.campaignInactive'
      }
      return 'EmptyView.configError'
    }
  }
}
</script>